import { createTypedHooks } from 'easy-peasy'
import { StoreModel } from './model'

const typedHooks = createTypedHooks<StoreModel>()

export const useActions = typedHooks.useStoreActions
export const useDispatch = typedHooks.useStoreDispatch
export const useStore = typedHooks.useStoreState
